/**
 * L2-R6: moved to @miq/platform (services/http-methods.class.ts). This shim keeps the old
 * import path working; new code should import from '@miq/platform' — or better, from
 * '@cbre/http', which is what this class has been deprecated in favour of.
 *
 * `environment.baseUrl` became the APP_API_BASE_URL token, provided by all three shells.
 */
export { HttpMethods } from '@miq/platform';
